import {useMutation, useQueryClient} from '@tanstack/react-query';

import {invalidatePayoutInstructions} from '@/features/trust-accounts/utils';
import {useApiClient} from '@/hooks';

import {payoutsApi} from '../api';

export function useCancelPayoutInstructionMutation(trustAccountId: string) {
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payoutInstructionId: string) =>
      payoutsApi.cancelPayout(client, trustAccountId, payoutInstructionId),
    onSuccess: () => invalidatePayoutInstructions(queryClient, trustAccountId)
  });
}
